import { CalendarDays, MapPin, Building2, Clock, Zap, ExternalLink } from "lucide-react";

export const EventCard = ({ title, dates, city, organizer, facts = [], deadline, benefit, ctaLabel, image, url, track, onCta, index = 0 }) => (
  <article className="relative rounded-3xl overflow-hidden bg-white border border-orange-100 shadow-[0_14px_44px_rgba(255,102,18,0.12)] flex flex-col" data-testid={`event-card-${index + 1}`}>
    <div className="relative h-52 sm:h-60">
      <img src={image} alt={title} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-brand-carbon/90 via-brand-carbon/30 to-transparent" />
      <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 bg-brand-orange text-white text-xs font-bold px-3 py-1.5 rounded-full shadow"><Zap className="w-3.5 h-3.5" /> Alta express en minutos</span>
      <div className="absolute bottom-4 left-5 right-5 text-white">
        <h3 className="text-2xl sm:text-3xl leading-tight">{title}</h3>
        <p className="mt-1 text-sm font-medium flex items-center gap-1.5 opacity-95"><CalendarDays className="w-4 h-4" /> {dates}</p>
      </div>
    </div>
    <div className="p-6 sm:p-7 flex-1 flex flex-col">
      <ul className="space-y-1.5 text-sm text-gray-700">
        <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-brand-orange shrink-0" /> {city}</li>
        <li className="flex items-center gap-2"><Building2 className="w-4 h-4 text-brand-orange shrink-0" /> {organizer}</li>
        {facts.map((f) => <li key={f} className="flex items-center gap-2"><span className="w-4 h-4 grid place-items-center text-brand-green font-bold">✓</span> {f}</li>)}
        {deadline && <li className="flex items-center gap-2 text-brand-orange-dark font-semibold"><Clock className="w-4 h-4 shrink-0" /> {deadline}</li>}
      </ul>
      <div className="mt-5 rounded-2xl bg-brand-cream border border-orange-100 p-4">
        <p className="text-xs uppercase tracking-wider text-brand-orange font-bold">Beneficio MenuThere</p>
        <p className="mt-1.5 text-sm text-gray-700 leading-relaxed">{benefit}</p>
      </div>
      <div className="mt-6 flex flex-col gap-3">
        <button onClick={onCta} className="btn-mt btn-mt-primary w-full" data-track={track} data-testid={`event-cta-${index + 1}`}>{ctaLabel}</button>
        {url && <a href={url} target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:text-brand-orange inline-flex items-center justify-center gap-1.5 transition-colors">Sitio oficial del evento <ExternalLink className="w-3.5 h-3.5" /></a>}
      </div>
    </div>
  </article>
);

export default EventCard;
